export default __webpack_public_path__ + "static/media/Rotate.d2e71572.svg";